import Box from "../box";
import { jsx as _jsx } from "react/jsx-runtime";
function TableToolbar(_ref) {
  let {
    color,
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    ...rest,
    color: color,
    width: 1,
    minHeight: 48,
    position: "relative",
    children: children
  });
}
export default TableToolbar;